// CSS Modules - component class name: MobileMenu__

<template>
  <nav :class="$style.drawer">
    <Slide right disableOutsideClick>
      <ul v-if="!isShop && !isMicrosite" :class="$style.primaryNav">
        <li v-for="elm in primaryLinks" :key="elm.title + elm.id">
          <a :class="{ MobileMenu__active: elm.isActive }" :href="elm.url || '#'">{{ elm.title }}</a>
          <bulma-accordion icon="custom" :slide="{ duration: '300ms', timerFunc: 'ease' }">
            <bulma-accordion-item v-for="subElm in elm.subNav" :key="subElm.title + subElm.id">
              <span slot="title" v-html="subElm.title"></span>
              <span slot="icon" :class="$style.icon"></span>
              <p slot="content">
                <ul :class="$style.subNav" v-for="column in subElm.subNav" :key="column.title + column.id">
                  <span v-html="column.title" :class="{[$style.MobileMenu__subNav_notitle]: !column.title}"></span>
                  <li v-for="link in column.subNav" :key="link.title + link.id">
                    <a :href="link.url || '#'" v-html="link.title"></a>
                  </li>
                </ul>
                <span :class="$style.ctas">
                  <a
                    v-for="(cta, index) in subElm.ctas" :key="index"
                    :href="cta.url"
                    :target="cta.target"
                    :class="$style.cta"
                    :style="{
                      backgroundColor: cta.colorCode,
                      '--color-hover': cta.colorCodeHover
                    }"
                    >
                    {{ cta.linkText }}
                  </a>
                </span>
              </p>
            </bulma-accordion-item>
          </bulma-accordion>
        </li>
      </ul>
      <ul v-if="isShop || isMicrosite" :class="$style.primaryNav">
        <li v-for="elm in primaryLinks" :key="elm.title + elm.id">
          <a
            :class="{ MobileMenu__active: elm.isActive }"
            :href="elm.url || '#'"
            v-html="elm.title"
            @click="preventDefaultIfNeeded($event, elm.url)"
          ></a>
          <ul :class="$style.subNav">
            <li v-for="link in elm.subNav" :key="link.title + link.id">
              <a :href="link.url || '#'" v-html="link.title"></a>
            </li>
          </ul>
        </li>
      </ul>
      <ul :class="$style.secondaryNav">
        <li v-for="elm in secondaryLinks" :key="elm.title + elm.id">
          <a :class="{ MobileMenu__active: elm.isActive }" :href="elm.url || '#'" v-html="elm.title"></a>
          <ul :class="$style.subNav">
            <li v-for="link in elm.subNav" :key="link.title + link.id">
              <a :href="link.url || '#'" v-html="link.title"></a>
            </li>
          </ul>
        </li>
      </ul>
    </Slide>
  </nav>
</template>

<script>
import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
import { Slide } from 'vue-burger-menu';

export default {
  name: "MobileMenu",
  components: {
    BulmaAccordion,
    BulmaAccordionItem,
    Slide
  },
  props: {
    isMicrosite: {
      type: Boolean,
      default: false
    },
    isShop: {
      type: Boolean,
      default: false
    },
    primaryLinks: {
    	type: Array,
      default: () => []
    },
    secondaryLinks: {
    	type: Array,
      default: () => []
    }
  },
  methods: {
    preventDefaultIfNeeded(event, url) {
      if (this.isMicrosite && url.includes("#")) {
        event.preventDefault();
        this.scrollTo(url);
        return false;
      }
      return true;
    },
    scrollTo(url) {
      const id = url.split("#")[1];
      const element = document.getElementById(id);
      if (element) {
        element.style.scrollMargin = "-20px";
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }
};
</script>

<style module lang="scss">
@import "./MobileMenu.scss";
</style>
